import React, { useState } from "react";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import Util from "@/Master/Util";

// 固定方法接口
export interface DialogMethods {
    open?: () => void;
    close?: () => void;
}

export const useDialogMethods = (key:string,callbacks?:DialogMethods) => {
    const [isOpen, setIsOpen] = useState(true);
    const [fcKey, setFcKey] = useState(key);
    const [isOk, setIsOK] = useState(false);

    const openDialog = () => {
        if (Util.isLog){
            console.log(SDialogManagerFC.tag,"Opening dialog...", fcKey);
        }
        setIsOpen(true);
        if (callbacks){
            callbacks.open;
        }
    };

    const closeDialog = () => {
        if (Util.isLog){
            console.log(SDialogManagerFC.tag,"Closing dialog...",fcKey);
        }
        setIsOpen(false);
        if(fcKey) SDialogManagerFC.closeDialog(fcKey);
        if (callbacks){
            callbacks.close;
        }
    };

    return { fcKey,isOpen, openDialog, closeDialog };
};
